import { EMPTY_STRING } from '../../../constants/common'
import { INTEGRATION_CONNECTION_STATUS } from '../../../constants/rentalPortal'

export const QA_NAME_RENTAL_PORTAL_INTEGRATIONS = 'rentalPortalIntegrations'

export const QA_NAME_INTEGRATIONS_RETRY = 'rentalPortalIntegrationsRetry'

export const INTEGRATIONS_SKELETON_ROWS = 2

export const QA_NAME_INTEGRATIONS_PANEL = 'rentalPortalIntegrationsPanel'

export const INTEGRATION_CONNECTION_TYPE = {
  immoscout24: 'OAuth (REST API)',
  immowelt: 'OpenImmo',
}

export const INTEGRATIONS_PAYLOAD_FIELD = {
  canConfigure: 'can_configure',
  portals: 'portals',
}

export const INTEGRATION_CONNECTION_STATUSES = {
  [INTEGRATION_CONNECTION_STATUS.connected]: {
    text: 'RentalPortal.IntegrationsStatusConnectedKey',
    textColor: 'var(--color-success)',
  },
  [INTEGRATION_CONNECTION_STATUS.error]: {
    text: 'RentalPortal.IntegrationsStatusErrorKey',
    textColor: 'var(--color-error)',
  },
  [INTEGRATION_CONNECTION_STATUS.needsReauth]: {
    text: 'RentalPortal.IntegrationsStatusReconnectRequiredKey',
    textColor: 'var(--color-warning)',
  },
  [INTEGRATION_CONNECTION_STATUS.notConnected]: {
    text: 'RentalPortal.IntegrationsStatusNotConnectedKey',
    textColor: 'var(--secondary-text-color)',
  },
}

export const INTEGRATION_COLUMN_NAME = {
  Integration: 'integration',
  LastChecked: 'last_checked_at',
  Status: 'status',
  Type: 'type',
}

export const INTEGRATIONS_COLUMNS_CONFIG = {
  [INTEGRATION_COLUMN_NAME.Integration]: {
    index: 0,
    name: INTEGRATION_COLUMN_NAME.Integration,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsIntegrationColumnKey',
    visible: true,
    width: 280,
  },
  [INTEGRATION_COLUMN_NAME.LastChecked]: {
    index: 3,
    name: INTEGRATION_COLUMN_NAME.LastChecked,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsLastCheckedColumnKey',
    visible: true,
    width: 200,
  },
  [INTEGRATION_COLUMN_NAME.Status]: {
    index: 1,
    name: INTEGRATION_COLUMN_NAME.Status,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsStatusColumnKey',
    visible: true,
    width: 260,
  },
  [INTEGRATION_COLUMN_NAME.Type]: {
    index: 2,
    name: INTEGRATION_COLUMN_NAME.Type,
    ordering_field: null,
    title: 'RentalPortal.IntegrationsTypeColumnKey',
    visible: true,
    width: 160,
  },
}

export const IntegrationConnectKind = {
  oauth: 'oauth',
  openimmo: 'openimmo',
}

export const INTEGRATION_CONNECT_KIND_BY_PORTAL = {
  immoscout24: IntegrationConnectKind.oauth,
  immowelt: IntegrationConnectKind.openimmo,
}

export const INTEGRATIONS_FORM_FIELD = {
  host: 'host',
  secret: 'secret',
  username: 'username',
}

export const INTEGRATIONS_FORM_INITIAL_VALUES = {
  [INTEGRATIONS_FORM_FIELD.host]: EMPTY_STRING,
  [INTEGRATIONS_FORM_FIELD.secret]: EMPTY_STRING,
  [INTEGRATIONS_FORM_FIELD.username]: EMPTY_STRING,
}

export const QA_NAME_INTEGRATIONS_CONNECT = 'rentalPortalIntegrationsConnect'

export const QA_NAME_INTEGRATIONS_DISCONNECT =
  'rentalPortalIntegrationsDisconnect'

export const QA_NAME_INTEGRATIONS_CONNECT_CANCEL =
  'rentalPortalIntegrationsConnectCancel'

export const IntegrationsAction = {
  connect: 'connect',
  disconnect: 'disconnect',
}

export const QA_NAME_INTEGRATIONS_IMPORT_LOG =
  'rentalPortalIntegrationsImportLog'
